import React from "react";
class SelectSchoolRedirectPage extends React.Component {
  render() {
    window.location.href = "https://schools.snap.app/";
    return null;
  }
}

export default SelectSchoolRedirectPage;
